import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { formatDateString } from '../../utils/dateUtils';
import FormattedReflection from '../Tasks/FormattedReflection';
import './ReflectionViewModal.css';

const ReflectionViewModal = ({ reflection, date, onClose, questions }) => {
  if (!reflection) return null;

  const modalContent = (
    <div
      className="reflection-modal-overlay"
      onClick={onClose}
      onKeyDown={(e) => e.key === 'Escape' && onClose()}
      role="button"
      tabIndex={0}
      aria-label="Close modal"
    >
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div className="reflection-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="reflection-modal-header">
          <div className="reflection-modal-title">
            <i className="fa-solid fa-book-open" />
            <h2>Reflection for {formatDateString(date)}</h2>
          </div>
          <button
            type="button"
            className="reflection-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        <div className="reflection-modal-body">
          {/* Reflection Entry */}
          <div className="reflection-modal-section reflection-entry-section">
            <h3>
              <i className="fa-solid fa-pen-fancy" /> Reflection Entry
            </h3>
            <FormattedReflection text={reflection.reflection_entry} />
          </div>

          {/* User Responses */}
          {reflection.user_responses && (
            <div className="reflection-modal-section responses-section">
              <h3>
                <i className="fa-solid fa-list-check" /> Your Responses
              </h3>
              <div className="responses-grid">
                {questions.map((question) => {
                  const response = reflection.user_responses[question.id];
                  if (!response && response !== 0) return null;

                  return (
                    <div key={question.id} className="response-card">
                      <div className="response-question">{question.question}</div>
                      <div className="response-answer">
                        {question.type === 'slider' ? `${response}/5` : response}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div className="reflection-modal-footer">
          <button type="button" className="btn-modal-close" onClick={onClose} aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

ReflectionViewModal.propTypes = {
  reflection: PropTypes.shape({
    reflection_entry: PropTypes.string,
    user_responses: PropTypes.object,
  }),
  date: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      question: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
};

ReflectionViewModal.defaultProps = {
  reflection: null,
};

export default ReflectionViewModal;
